export const RISK_STYLES = {
  low: "bg-emerald-50 text-emerald-700 border-emerald-200",
  medium: "bg-amber-50 text-amber-700 border-amber-200",
  high: "bg-orange-50 text-orange-700 border-orange-200",
  critical: "bg-red-50 text-red-700 border-red-200",
};

export const STATUS_STYLES = {
  open: "bg-blue-50 text-blue-700 border-blue-200",
  in_progress: "bg-indigo-50 text-indigo-700 border-indigo-200",
  review: "bg-amber-50 text-amber-700 border-amber-200",
  pending: "bg-slate-100 text-slate-700 border-slate-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  done: "bg-emerald-50 text-emerald-700 border-emerald-200",
  closed: "bg-slate-100 text-slate-500 border-slate-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  granted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  withdrawn: "bg-orange-50 text-orange-700 border-orange-200",
  refused: "bg-red-50 text-red-700 border-red-200",
  expired: "bg-slate-100 text-slate-500 border-slate-200",
  sent: "bg-emerald-50 text-emerald-700 border-emerald-200",
  submitted: "bg-blue-50 text-blue-700 border-blue-200",
  verified: "bg-emerald-50 text-emerald-700 border-emerald-200",
  responded: "bg-emerald-50 text-emerald-700 border-emerald-200",
  contained: "bg-amber-50 text-amber-700 border-amber-200",
  investigating: "bg-orange-50 text-orange-700 border-orange-200",
  implemented: "bg-emerald-50 text-emerald-700 border-emerald-200",
  partial: "bg-amber-50 text-amber-700 border-amber-200",
  not_implemented: "bg-red-50 text-red-700 border-red-200",
  verified_ok: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const NAV = [
  { group: "Overview", items: [
    { path: "/app/dashboard", label: "Dashboard", icon: "LayoutDashboard" },
    { path: "/app/company-profile", label: "Company Profile", icon: "Building2" },
    { path: "/app/onboarding", label: "Org Onboarding", icon: "ClipboardList" },
  ]},
  { group: "Assessment", items: [
    { path: "/app/assessment", label: "DPDP Assessment", icon: "ClipboardCheck" },
    { path: "/app/website-scanner", label: "Website Scanner", icon: "ScanLine" },
    { path: "/app/gaps", label: "Gaps & Tasks", icon: "AlertTriangle" },
  ]},
  { group: "Data Governance", items: [
    { path: "/app/data-inventory", label: "Data Inventory", icon: "Database" },
    { path: "/app/data-discovery", label: "Data Discovery", icon: "ScanSearch" },
    { path: "/app/discovery-agents", label: "Discovery Agents", icon: "Cpu" },
    { path: "/app/processing-activities", label: "Processing Activities", icon: "Workflow" },
    { path: "/app/purposes", label: "Purpose Registry", icon: "Target" },
  ]},
  { group: "Notices & Consent", items: [
    { path: "/app/notices", label: "Notice Generator", icon: "FileText" },
    { path: "/app/consents", label: "Consent Manager", icon: "ShieldCheck" },
    { path: "/app/rights-requests", label: "Rights Requests", icon: "Users" },
    { path: "/app/grievances", label: "Grievances", icon: "MessageSquareWarning" },
  ]},
  { group: "Retention & Compliance", items: [
    { path: "/app/retention-rules", label: "Retention & Deletion", icon: "CalendarClock" },
    { path: "/app/children-data", label: "Children's Data", icon: "Baby" },
  ]},
  { group: "Third-Party", items: [
    { path: "/app/vendors", label: "Vendors / Processors", icon: "Truck" },
    { path: "/app/cross-border", label: "Cross-Border Transfers", icon: "Globe" },
  ]},
  { group: "Security & Breach", items: [
    { path: "/app/security-controls", label: "Security Safeguards", icon: "Lock" },
    { path: "/app/breaches", label: "Breach Command Center", icon: "AlertOctagon" },
    { path: "/app/cert-in", label: "CERT-In Reporting", icon: "Radio" },
  ]},
  { group: "DPIA & Audit", items: [
    { path: "/app/dpia", label: "DPIA Workspace", icon: "SearchCode" },
    { path: "/app/sdf", label: "SDF Readiness", icon: "Award" },
    { path: "/app/compliance-controls", label: "Controls & Evidence", icon: "ShieldCheck" },
    { path: "/app/audit-logs", label: "Audit Logs", icon: "ScrollText" },
  ]},
  { group: "Documents & Reports", items: [
    { path: "/app/policy-generator", label: "Policy Generator", icon: "FileEdit" },
    { path: "/app/documents", label: "Document Repository", icon: "Files" },
    { path: "/app/evidence", label: "Evidence Vault", icon: "FolderLock" },
    { path: "/app/reports", label: "Reports", icon: "BarChart3" },
  ]},
  { group: "Administration", items: [
    { path: "/app/notifications", label: "Notifications", icon: "Bell" },
    { path: "/app/connectors", label: "Integrations & Connectors", icon: "Plug" },
    { path: "/app/users", label: "User Management", icon: "UserCog" },
    { path: "/app/settings", label: "Settings", icon: "Settings" },
  ]},
];
